import React from "react";
import qrcode from '../../assets/images/qrcode.png';
import numberbeautify from "../../utils/numberbeautify";
import './sellitemprint.css';
import Logo from '../../assets/images/logo.png'
import Qrcode from "../../assets/images/qrcode.png";
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";
import moment from "moment/moment";

export const Sellitemprint = React.forwardRef((props, ref) => {
  return (
     <div ref={ref}>
        <div>
          <img src={Logo} className="h-72 absolute left-1/2 top-[50%] transform -translate-x-1/2 -translate-y-1/2 opacity-5" />
        </div>
        <div dir="rtl">
          <div className="py-4">
            <div className="px-14 py-1 relative flex justify-between items-center">
              <div>
                <p className="whitespace-nowrap text-slate-400 text-right">بەروار</p>
                <p className="whitespace-nowrap font-medium text-right text-[#D9A919]">{moment(props?.sell_invoice_date).format("YYYY-MM-DD hh:mm A")}</p>
              </div>
              <div>
                <img src={Qrcode} className="h-16 mb-2" />
              </div>
              <div className="flex">
                <div className="mx-3">
                    <p className="whitespace-nowrap text-slate-400 text-right">ژمارەی پسوڵە #</p>
                    <p className="whitespace-nowrap font-medium text-right text-[#D9A919]">{props?.invoiceno}</p>
                </div>
                <div className="mx-3">
                    <p className="whitespace-nowrap text-slate-400 text-right">نرخی دۆلار</p>
                    <p className="whitespace-nowrap font-medium text-right text-[#D9A919]">{numberbeautify(props?.sell_invoice_dollar_price)}</p>
                </div>
              </div>
            </div>

            <div className="bg-slate-100 px-14 py-2 text-sm">
              <table className="w-full border-collapse border-spacing-0">
                <tbody>
                  <tr>
                    <td className="w-1/2 align-top">
                      <div className="text-sm text-neutral-600">
                        <div className="flex">
                          <p className="font-medium text-base">بەڕێز: </p>
                          <p className="font-medium text-base mx-1">{props?.customer_name}</p>
                        </div>
                        <div className="flex">
                          <p className="text-base">ناونیشان: </p>
                          <p className="text-base mx-1"> {props?.customer_address} </p>
                        </div>
                        <div className="flex">
                          <p className="text-base">ژمارەی تەلەفۆن: </p>
                          <p className="text-base mx-1"> {props?.customer_phone} </p>
                        </div>
                        <div className="flex">
                          <p className="text-base">دۆخی پسوڵە: </p>
                          <p className="text-base mx-1"> {props?.sell_invoice_type=="loan"?"قەرز":"کاش"} </p>
                        </div>
                        <p></p>
                        <p></p>
                      </div>
                    </td>
                    <td className="w-1/2 align-top text-right">
                      <div className="text-sm text-neutral-600">
                        <p className="font-medium text-xl text-[#D9A919]">کۆمپانیای خەندەی ماڵ</p>
                        <p className="text-base">بۆ بازرگانی گشتی سنوردار / پێداویستی ناوماڵ</p>
                        <p className="text-base">سلێمانی - ژاڵەی سەروو - کۆگاکانی ژووری بازرگانی</p>
                        <p className="text-base">ژمارەی گەنجینە: ۲۷٥</p>
                        <p className="text-base" dir="ltr">0770 159 1344 - 0770 152 8160</p>
                        <p></p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="px-6 py-10 text-sm text-neutral-700">
              <table className="w-full border-collapse border-spacing-0">
                <thead>
                  <tr>
                    <td className="border-b-2 border-[#D9A919] pb-3 pl-3 font-medium text-main text-[#D9A919]">#</td>
                    <td className="border-b-2 border-[#D9A919] pb-3 pl-2 font-medium text-main text-[#D9A919]">ناوی کاڵا - کۆد</td>
                    {/* <td className="border-b-2 border-[#D9A919] pb-3 pl-2 font-medium text-main text-[#D9A919]">کۆد</td> */}
                    <td className="border-b-2 border-[#D9A919] pb-3 pl-2 text-right font-medium text-main text-[#D9A919]">دۆخی فرۆش</td>
                    <td className="border-b-2 border-[#D9A919] pb-3 pl-2 text-center font-medium text-main text-[#D9A919]">بڕ</td>
                    <td className="border-b-2 border-[#D9A919] pb-3 pl-2 text-center font-medium text-main text-[#D9A919]">نرخ</td>
                    <td className="border-b-2 border-[#D9A919] pb-3 pl-2 text-center font-medium text-main text-[#D9A919]">نرخ (دینار)</td>
                    <td className="border-b-2 border-[#D9A919] pb-3 pl-2 text-right font-medium text-main text-[#D9A919]">کۆی نرخ</td>
                  </tr>
                </thead>
                <tbody>
                  {props?.items?.map((item, index) => (
                    <tr key={index}>
                      <td className="border-b py-3 pl-3">{index + 1}.</td>
                      <td className="border-b py-3 pl-2">
                        <div className="flex">
                          <div className="ml-1">
                            {item.item_name}
                          </div>
                          <div>
                            -
                          </div>
                          <div className="mr-1">
                            {item.item_barcode}
                          </div>
                        </div>
                      </td>
                      {/* <td className="border-b py-3 pl-2">{item.item_barcode}</td> */}
                      <td className="border-b py-3 pl-2 text-right">{item.item_sell_state=="pay"?"فرۆش":"دیاری"}</td>
                      <td className="border-b py-3 pl-2 text-center">{item?.item_unit_one} {Math.floor(item?.item_qty/item?.item_unit_one_of_many)}/{money_rounding(Number(item?.item_qty) % item?.item_unit_one_of_many)} {item?.item_unit_many} {Number(Math.floor(item.item_qty/item.item_unit_one_of_many))>=1?"("+item.item_unit_one_of_many+")":null}</td>
                      {/* <td className="border-b py-3 pl-2 text-center">{item?.item_unit_one} {Math.floor(item.item_qty)}/{Math.round((Number(item.item_qty)-Number(Math.floor(item.item_qty)))*item.item_unit_one_of_many)} {item?.item_unit_many} {Number(Math.floor(item.item_qty))>=1?"("+item.item_unit_one_of_many+")":null}</td> */}
                      <td className={item.item_sell_state=="pay"?"border-b py-3 pl-2 text-center":"border-b py-3 pl-2 text-center line-through"}>{numberbeautify(item.item_sell_price)} $</td>
                      <td className={item.item_sell_state=="pay"?"border-b py-3 pl-2 text-center":"border-b py-3 pl-2 text-center line-through"}>{numberbeautify(money_rounding(Number(item.item_sell_price)*Number(props?.sell_invoice_dollar_price)))}</td>
                      <td className={item.item_sell_state=="pay"?"border-b py-3 pl-2 text-right":"border-b py-3 pl-2 text-right line-through"}>{numberbeautify(money_rounding(
                        Number(item.item_sell_price) * (Number(item.item_qty))
                      ))} $</td>
                    </tr>
                  ))}
                  <tr>
                    <td colspan="2">
                      <table className="w-1/2 border-collapse border-spacing-0">
                        <tbody>
                          <tr>
                            <td className="w-full"></td>
                            <td>
                              <table className="w-full border-collapse border-spacing-0">
                                <tbody>
                                  <tr>
                                    <td className="border-b p-3">
                                      <div className="whitespace-nowrap text-slate-400">بڕی واسڵکراو</div>
                                    </td>
                                    <td className="border-b p-3 text-right">
                                      <div className="whitespace-nowrap font-medium text-[#D9A919]">{
                                        props?.sell_invoice_type=="loan"?
                                        numberbeautify(
                                          props?.loan_back_amount
                                        )
                                      :
                                      numberbeautify(money_rounding(
                                          Number(props?.items?.reduce(
                                            (a, v) =>
                                              (a =
                                                Number(a) +
                                                (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                            0
                                          ))*Number(1-props?.sell_invoice_discount/100)
                                          )
                                        )} $
                                      </div>
                                    </td>
                                  </tr>
                                  {props?.sell_invoice_type=="cash"?
                                  <tr>
                                    <td className="border-b p-3">
                                      <div className="whitespace-nowrap text-slate-400">بڕی واسڵکراو (دینار)</div>
                                    </td>
                                    <td className="border-b p-3 text-right">
                                      <div className="whitespace-nowrap font-medium text-[#D9A919]">
                                        {
                                        props?.sell_invoice_type=="loan"?
                                        numberbeautify(iqd_rounding((money_rounding(
                                          Number(props?.loan_back_amount)*Number(props?.sell_invoice_dollar_price))))
                                        )
                                      :
                                      numberbeautify(iqd_rounding((money_rounding(
                                          Number(props?.items?.reduce(
                                            (a, v) =>
                                              (a =
                                                Number(a) +
                                                (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                            0
                                          ))*Number(1-props?.sell_invoice_discount/100)
                                          ))*Number(props?.sell_invoice_dollar_price))
                                        )} IQD
                                      </div>
                                    </td>
                                  </tr>:null}
                                  <tr>
                                    <td className="bg-[#D9A919] p-3">
                                      <div className="whitespace-nowrap font-medium text-white">بڕی ماوە</div>
                                    </td>
                                    <td className="bg-[#D9A919] p-3 text-right">
                                      <div className="whitespace-nowrap font-medium text-white">
                                        {numberbeautify(money_rounding(props?.sell_invoice_type=="loan"?
                                          (Number(props?.items?.reduce(
                                            (a, v) =>
                                              (a =
                                                Number(a) +
                                                (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                            0
                                          ))*Number(1-props?.sell_invoice_discount/100))-Number(props?.loan_back_amount)
                                          :0)
                                        )} $
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="bg-[#D9A919] p-3">
                                      <div className="whitespace-nowrap font-medium text-white">کۆی قەرزی ماوە</div>
                                    </td>
                                    <td className="bg-[#D9A919] p-3 text-right">
                                      <div className="whitespace-nowrap font-medium text-white">
                                        {numberbeautify(money_rounding(
                                          Number(props?.remained_loan)))} $
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td colspan="5">
                      <table className="w-full border-collapse border-spacing-0">
                        <tbody>
                          <tr>
                            <td className="w-full"></td>
                            <td>
                              <table className="w-full border-collapse border-spacing-0">
                                <tbody>
                                  <tr>
                                    <td className="border-b p-3">
                                      <div className="whitespace-nowrap text-slate-400">کۆی نرخ</div>
                                    </td>
                                    <td className="border-b p-3 text-right">
                                      <div className="whitespace-nowrap font-medium text-[#D9A919]">{
                                        numberbeautify(
                                          props?.items?.reduce(
                                            (a, v) =>
                                              (a =
                                                Number(a) +
                                                (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                            0
                                          )
                                        )} $
                                      </div>
                                    </td>
                                  </tr>
                                  {/* {props?.sell_invoice_discount>0&&( */}
                                    <tr>
                                      <td className="p-3">
                                        <div className="whitespace-nowrap text-slate-400">داشکاندن</div>
                                      </td>
                                      <td className="p-3 text-right">
                                        <div className="whitespace-nowrap font-medium text-[#D9A919]">
                                          {numberbeautify(money_rounding(
                                            Number(props?.items?.reduce(
                                              (a, v) =>
                                                (a =
                                                  Number(a) +
                                                  (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                              0
                                            ))*Number(props?.sell_invoice_discount/100)
                                            )
                                          )} $
                                        </div>
                                      </td>
                                    </tr>
                                  {/* )} */}
                                  <tr>
                                    <td className="bg-[#D9A919] p-3">
                                      <div className="whitespace-nowrap font-medium text-white">کۆی گشتی</div>
                                    </td>
                                    <td className="bg-[#D9A919] p-3 text-right">
                                      <div className="whitespace-nowrap font-medium text-white">
                                        {numberbeautify(money_rounding(
                                          Number(props?.items?.reduce(
                                            (a, v) =>
                                              (a =
                                                Number(a) +
                                                (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                            0
                                          ))*Number(1-props?.sell_invoice_discount/100)
                                          )
                                        )} $
                                      </div>
                                    </td>
                                  </tr>
                                  {props?.sell_invoice_type=="cash"?
                                  <tr>
                                    <td className="bg-[#D9A919] p-3">
                                      <div className="whitespace-nowrap font-medium text-white">کۆی گشتی (دینار) </div>
                                    </td>
                                    <td className="bg-[#D9A919] p-3 text-right">
                                      <div className="whitespace-nowrap font-medium text-white">
                                        {numberbeautify(iqd_rounding((money_rounding(
                                          Number(props?.items?.reduce(
                                            (a, v) =>
                                              (a =
                                                Number(a) +
                                                (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                            0
                                          ))*Number(1-props?.sell_invoice_discount/100)
                                          ))*Number(props?.sell_invoice_dollar_price))
                                        )} IQD
                                      </div>
                                    </td>
                                  </tr>:null}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="px-14 text-sm text-neutral-700">
              <p className="text-[#D9A919] font-medium">ئیمزا</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
            </div>

            {/* <div className="px-14 py-10 text-sm text-neutral-700">
              <p className="text-[#D9A919] font-medium">سوپاس</p>
              <p className="italic">سوپاس بۆ هەڵبژاردنی ئێمە</p>
            </div> */}

              {/* <footer className="fixed bottom-0 left-0 bg-slate-100 w-full text-neutral-600 text-center text-xs py-3">
                Xandaymal
                <span className="text-slate-300 px-2">|</span>
                support@xandaymal.co
                <span className="text-slate-300 px-2">|</span>
                https://xandaymal.co
              </footer> */}
            </div>
          </div>
      </div>
    // </div>
  );
});